import Cookies from "js-cookie";
import { createActionType, createAsyncAction } from "./create-actions";

export const GET_COOPERATION_REQ = createActionType("GET_COOPERATION_REQ ");
export const GET_COOPERATION_REQ_BY_ID = createActionType(
  "GET_COOPERATION_REQ_BY_ID"
);
export const REMOVE_COOPERATION_REQ = createActionType(
  "REMOVE_COOPERATION_REQ"
);

export const getCooperationsReq = () =>
  createAsyncAction(
    GET_COOPERATION_REQ,
    "/cooperation_req/get_all_cooperation_reqs",
    "get",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const getACooperationReqById = (data: any) =>
  createAsyncAction(
    GET_COOPERATION_REQ_BY_ID,
    `/cooperation_req/get_cooperation_req_by_id/${data}`,
    "get",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );

export const removeCooperationReq = (data: any) =>
  createAsyncAction(
    REMOVE_COOPERATION_REQ,
    `/cooperation_req/remove_cooperation_req/${data}`,
    "delete",
    undefined,
    {
      Authorization: `Bearer ${Cookies.get("token")}`,
    }
  );
